import { Scheme } from '@/models';

export const schemesDisplayValue = (schemes: Scheme[] = []): string =>
  schemes.length === 1 ? schemes[0].name : `${schemes.length} planning schemes`;
